<template>
    <v-expansion-panels accordion flat>
        <v-expansion-panel>
            <v-expansion-panel-header v-slot="{open}" class="pa-0">
                <label :class="{'primary--text' : open}">{{label}}</label>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-tabs icons-and-text>
                    <v-tab v-for="b in breakpoints" :key="b.id">
                        {{b.name}}<v-icon>{{b.icon}}</v-icon>
                    </v-tab>

                    <v-tab-item v-for="b in breakpoints" :key="b.id">
                        <font-setting :label="$translate('Font')" v-model="style[b.id].font" />
                        <css-size-setting :label="$translate('Size')" v-model="style[b.id].size" />
                        <v-checkbox :label="$translate('Bold')" v-model="style[b.id].bold" color="zoezi-edit-color" />
                        <v-checkbox :label="$translate('Cursive')" v-model="style[b.id].italic" color="zoezi-edit-color" />
                        <v-checkbox :label="$translate('Uppercase letters')" v-model="style[b.id].uppercase" color="zoezi-edit-color" />
                        <css-size-setting :label="$translate('Kerning')" v-model="style[b.id].letterspacing" />
                        <css-size-setting :label="$translate('Line spacing')" v-model="style[b.id].lineheight" :allowNumber="true"/>
                        <color-setting :label="$translate('Color')" v-model="style[b.id].color" />
                    </v-tab-item>
                </v-tabs>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import FontSetting from './FontSetting.vue'
import CssSizeSetting from './CssSizeSetting.vue'
import ColorSetting from './ColorSetting.vue'
import Vue from 'vue'
export default {
    name: 'zoezi-text-style-setting',

    props: ['value', 'label'],

    components: {
        FontSetting,
        CssSizeSetting,
        ColorSetting
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                if (!value) {
                    value = {};
                }
                this.style = value;
                this.breakpoints.forEach(b => {
                    if (!this.style[b.id]) {
                        this.style = Object.assign({}, this.style);
                        Vue.set(this.style, b.id, {})
                    }
                })
            }
        },
        style: {
            deep: true,
            handler(style) {
                this.$emit('input', style);
            }
        }
    },

    data: () => ({
        style: null,
        breakpoints: [
            {id: 'mobile', name: 'Mobil', icon: 'mdi-cellphone-iphone'},
            {id: 'desktop', name: 'Dator', icon: 'mdi-desktop-mac'}
        ]
    }),

}
</script>
